import cn from 'classnames'
import React, { ComponentProps } from 'react'

type DatabaseBackupIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function DatabaseBackupIcon(props: DatabaseBackupIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('DatabaseBackupIcon', className)}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect x="0.5" width="24" height="24" rx="4" fill="#EBF2FE" />
      <path
        d="M18.5 7.33325C18.5 8.43782 15.8137 9.33325 12.5 9.33325C9.18629 9.33325 6.5 8.43782 6.5 7.33325M18.5 7.33325C18.5 6.22868 15.8137 5.33325 12.5 5.33325C9.18629 5.33325 6.5 6.22868 6.5 7.33325M18.5 7.33325V10.1999M6.5 7.33325L6.5 16.6666C6.49958 17.099 6.91968 17.5199 7.69733 17.866C8.47499 18.2122 9.56828 18.465 10.8133 18.5866M6.5 11.9999C6.49904 12.3727 6.81063 12.7381 7.39962 13.055C7.98861 13.3719 8.83155 13.6276 9.83334 13.7933M12.5 11.9999V14.6666M12.5 14.6666H15.1667M12.5 14.6666L13.8933 13.2733C14.4733 12.6933 15.28 12.3333 16.1667 12.3333C16.9623 12.3333 17.7254 12.6493 18.288 13.2119C18.8506 13.7745 19.1667 14.5376 19.1667 15.3333C19.1667 16.0329 18.9465 16.7147 18.5375 17.2823C18.1284 17.8498 17.5511 18.2743 16.8874 18.4955C16.2237 18.7168 15.5072 18.7236 14.8394 18.515C14.1717 18.3064 13.5864 17.8929 13.1667 17.3333"
        stroke="#4489F9"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
